import React from "react";

export default function StatsStrip({ stats }) {
  if (!stats) return null;
  const items = [
    { label: "Active", value: stats.active ?? 0, color: "#E63946", testid: "stat-active" },
    { label: "Contained", value: stats.contained ?? 0, color: "#FFB347", testid: "stat-contained" },
    { label: "Out", value: stats.out ?? 0, color: "#94A39A", testid: "stat-out" },
    { label: "Alerts", value: stats.alerts ?? 0, color: "#F2542D", testid: "stat-alerts" },
  ];
  return (
    <div data-testid="stats-strip" className="grid grid-cols-4 border-y border-tac-border">
      {items.map((it) => (
        <div
          key={it.label}
          data-testid={it.testid}
          className="px-3 py-2.5 border-r border-tac-border last:border-r-0 bg-tac-bg/30"
        >
          <div className="text-[12px] uppercase tracking-[0.15em] font-bold text-tac-faint mb-0.5">
            {it.label}
          </div>
          <div
            className="font-display font-black text-2xl tabular leading-none"
            style={{ color: it.color }}
          >
            {it.value}
          </div>
        </div>
      ))}
    </div>
  );
}
